import React, { Component, PropTypes } from 'react';
import invariant from 'invariant';
import CSSModules from 'react-css-modules';
import Work from '../components/Work';
import Series from '../components/Series';
import FullWidthRegion from '../components/FullWidthRegion';
import Separator from '../components/Separator';
import Everything from '../components/Everything';
import styles from './WorkPage.css';
import lazy from '../lib/lazy';
import * as library from '../lib/library';

class WorkPage extends Component {
  static propTypes = {
    params: PropTypes.shape({
      workId: PropTypes.string,
      index: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    }).isRequired,
  };

  render() {
    const work = library.getWorkById(this.props.params.workId);

    document.title = `${work.title} by Jennifer Zwick`;

    // Parse index param. If not given, it will be parsed as NaN.
    let imgIndex = parseInt(this.props.params.index, 10);

    if (Number.isNaN(imgIndex)) {
      imgIndex = 0;

    } else if (imgIndex > 0) {
      imgIndex = imgIndex - 1;
    }

    const series = library.getSeriesByWorkId(work.id);
    let worksInSeries;

    if (series) {
      worksInSeries = series.works.map(id => library.getWorkById(id));

      worksInSeries = series.works.map((id) => {
        const seriesWork = library.getWorkById(id);
        invariant(seriesWork, `Work "${id}" does not exist, from the series "${series.id}".`);
        return seriesWork;
      });
    }

    return (
      <div>
        <Work onWorkLoad={() => lazy.refresh()} work={work} currentImageIndex={imgIndex} />

        {
          series ?
            <Separator /> :
            null
        }

        {
          series ?
            <FullWidthRegion>
              <Series series={series} works={worksInSeries} />
            </FullWidthRegion> :
            null
        }

        <Everything />
      </div>
    );
  }
}

export default CSSModules(WorkPage, styles, { errorWhenNotFound: false });



// WEBPACK FOOTER //
// ./application/js/pages/WorkPage.js